export default __webpack_public_path__ + "static/media/@marlosvitorio.b71c8b5a.PNG";